module.exports = __webpack_public_path__ + "media/images/weather/102_night-85cc8550e8680d9df22a986b4dc1b79d.png";